export default __webpack_public_path__ + "static/media/858_6.0a51e04b.jpg";